import ButtonPrimary from "components/Button/ButtonPrimary";
import React, { FC, ReactNode } from "react";
import {ArrowRightIcon} from "@heroicons/react/solid";
import ButtonSecondary from "../../components/Button/ButtonSecondary";

export interface SectionHero2Props {
    className?: string;
    rightImg: string;
    heading: ReactNode;
    subHeading: string;
    btnText: string;
}

const SectionHero2: FC<SectionHero2Props> = ({
                                                 className = "",
                                                 rightImg,
                                                 heading,
                                                 subHeading,
                                                 btnText,
                                             }) => {
    return (
        <div
            className={`SectionHero2 relative ${className}`}
            data-nc-id="SectionHero2"
        >
            <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
                <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
                    <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
                        {heading}
                    </h2>
                    <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            {subHeading}
          </span>
                    <div className="flex space-x-4 mt-11">
                        <ButtonPrimary href={"/Markets"}>See The Data <ArrowRightIcon className="w-5 h-5 ml-2"/>
                        </ButtonPrimary>
                        <ButtonSecondary href={"/blog"}>
                            Read The Latest
                            <ArrowRightIcon className="w-5 h-5 ml-2"/>
                        </ButtonSecondary>
                    </div>
                </div>
                <div className="flex-grow">
                    <img className="w-full" src={rightImg} alt="" />
                </div>
            </div>
        </div>
    );
};

export default SectionHero2;
